import { ZxcvbnFactory } from "@zxcvbn-ts/core";
import * as zxcvbnCommonPackage from "@zxcvbn-ts/language-common";
import * as zxcvbnEnPackage from "@zxcvbn-ts/language-en";

const options = {
  translations: zxcvbnEnPackage.translations,
  graphs: zxcvbnCommonPackage.adjacencyGraphs,
  dictionary: {
    ...zxcvbnCommonPackage.dictionary,
    ...zxcvbnEnPackage.dictionary,
  },
};

const zxcvbn = new ZxcvbnFactory(options);

export const MIN_STRONG_PASSWORD_SCORE = 4;

export const getPasswordStrengthScore = (password: string): number => {
  const result = zxcvbn.check(password);
  return result.score;
};

export const isStrongPassword = (password: string): boolean => {
  return getPasswordStrengthScore(password) >= MIN_STRONG_PASSWORD_SCORE;
};
